export const FORM = {
  EMAIL_MAX_LENGTH: 255,
  NAME_MAX_LENGTH: 60,
  PHONE_NUMBER_MAX_LENGTH: 16,
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_MAX_LENGTH: 20,
  REFERENCE_URL_MAX_LENGTH: 255,
  GITHUB_USERNAME_MAX_LENGTH: 39,
  NOTE_MAX_LENGTH: 10000,
} as const;

export default FORM;
